import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * CLOUDWEB-18219 Добавление видео в сториз
 */
export const enableVideoInStories = getFeature('enable-video-in-stories') || false;
